/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_common_value = /** @type {(inputs: {}) => string} */ () => {
	return `Valor`
};

const en_common_value = /** @type {(inputs: {}) => string} */ () => {
	return `Value`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const common_value = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_value(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("common_value", locale)
	if (locale === "es") return es_common_value(inputs)
	return en_common_value(inputs)
};
export { common_value as "common.value" }